import { getGridDefinition, WorksheetGridKeys } from 'Components/WorksheetGrids/WorksheetGridDefinitions';
import React from 'react';
import { NavLink } from 'react-router-dom';
import './BulkEntryNav.scss';

/**
 * Displays links to all available bulk entry ("worksheet grid") pages
 */
const BulkEntryNav: React.FC = () => {
  return (
    <nav className="BulkEntryNav">
      <h1 className="BulkEntryNav-Heading">Bulk Entry</h1>
      {/* Specialised bulk entry pages */}
      {[WorksheetGridKeys.WetMassEntry, WorksheetGridKeys.DryMassEntry].map((k) => (
        <NavLink to={`/grid/${k}`} className="BulkEntryNav-Item" key={k}>
          {getGridDefinition(k).title}
        </NavLink>
      ))}
      {/* Configurable batch update page */}
      <NavLink to={`/batch-update`} className="BulkEntryNav-Item">
        Batch Update
      </NavLink>
    </nav>
  );
};

export { BulkEntryNav };
export default BulkEntryNav;
